import { render, staticRenderFns } from "./protocolModel.vue?vue&type=template&id=afa96232&scoped=true&"
import script from "./protocolModel.vue?vue&type=script&lang=js&"
export * from "./protocolModel.vue?vue&type=script&lang=js&"
import style0 from "./protocolModel.vue?vue&type=style&index=0&id=afa96232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!//node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa96232",
  null
  
)

export default component.exports